<template>
  <div>
    <slot></slot>
    <figure class="product-image-area">
      <a :href="$itemLink(product.stock_number)"
         :title="product_name" class="product-image">
        <img v-if="getCartThumbnail(product)"
             :src="getCartThumbnail(product)"
             :alt="product_name">
        <base-missing-image v-else :alt="product_name" />
      </a>
    </figure>
    <div class="product-details-area">
      <h2 class="product-name"><a
          :href="$itemLink(product.stock_number)"
          :title="product_name">{{product_name}}</a>
      </h2>

      <div class="cart-qty-price">
        {{parseFloat(product.quantity)}} X
        <base-price :price="product.price"
                    class="product-price"/>
      </div>
    </div>
  </div>
</template>

<script>
  import productHelpers from "vue-src/utils/productHelpers"

  export default {
    name: "cart-dropdown-item-display",
    props: {
      product: {
        type: Object,
        required: true,
      }
    },
    computed:{
      product_name(){
        return productHelpers.getProductName(this.product)
      }
    },
    methods:{
      getCartThumbnail: productHelpers.getCartThumbnail,
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/cart-dropdown-item-display.vue